export const STANDARD_FONT_FAMILY =
  '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"';

export const MONOSPACE_FONT_FAMILY =
  'ui-monospace, Menlo, Monaco, "Cascadia Mono", "Segoe UI Mono", "Roboto Mono", "Oxygen Mono", "Ubuntu Monospace", "Source Code Pro", "Fira Mono", "Droid Sans Mono", "Courier New", monospace';

const MODERN_SANS = '"Helvetica Neue", "Arial Nova", "Nimbus Sans", Arial, sans-serif';
const BOOK_SANS = 'Optima, Candara, "Noto Sans", source-sans-pro, sans-serif';
const ORGANIC_SANS = 'Seravek, "Gill Sans Nova", Ubuntu, Calibri, "DejaVu Sans", source-sans-pro, sans-serif';
const GEOMETRIC_SANS = 'Avenir, "Avenir Next LT Pro", Montserrat, Corbel, "URW Gothic", source-sans-pro, sans-serif';
const HEAVY_SANS =
  'Bahnschrift, "DIN Alternate", "Franklin Gothic Medium", "Nimbus Sans Narrow", sans-serif-condensed, sans-serif';
const ROUNDED_SANS =
  'ui-rounded, "Hiragino Maru Gothic ProN", Quicksand, Comfortaa, Manjari, "Arial Rounded MT Bold", Calibri, source-sans-pro, sans-serif';
const MODERN_SERIF = 'Charter, "Bitstream Charter", "Sitka Text", Cambria, serif';
const BOOK_SERIF = '"Iowan Old Style", "Palatino Linotype", "URW Palladio L", P052, serif';
const MONOSPACE = '"Nimbus Mono PS", "Courier New", "Cutive Mono", monospace';

// Based on https://modernfontstacks.com/#font-stacks
export const EMAIL_TEMPLATES_DEFAULT_FONT_FAMILIES = [
  { value: MODERN_SANS, label: 'Modern sans' },
  { value: BOOK_SANS, label: 'Book sans' },
  { value: ORGANIC_SANS, label: 'Organic sans' },
  { value: GEOMETRIC_SANS, label: 'Geometric sans' },
  { value: HEAVY_SANS, label: 'Heavy sans' },
  { value: ROUNDED_SANS, label: 'Rounded sans' },
  { value: MODERN_SERIF, label: 'Modern serif' },
  { value: BOOK_SERIF, label: 'Book serif' },
  { value: MONOSPACE, label: 'Monospace' },
] as const;
export const EMAIL_TEMPLATES_BASE_FONT_FAMILY = EMAIL_TEMPLATES_DEFAULT_FONT_FAMILIES[0];
